import { owaSuiteHeaderRendered } from '../actions/owaSuiteHeaderRendered';
import { owaSettingsButtonID } from '../components/OwaSuiteHeader';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { WebPushDiscovery } from 'owa-webpush-notifications';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { orchestrator } from 'satcheljs';
var id = 'webpushdiscoverycontainer';
export var attachWebPushDiscovery = orchestrator(owaSuiteHeaderRendered, function () {
    if (isControlFeatureEnabled('fwk-webPushNotification')) {
        var target_1 = document.getElementById(owaSettingsButtonID);
        if (target_1 !== null) {
            var webPushDiscoveryContainer = document.createElement('div');
            webPushDiscoveryContainer.id = id;
            document.body.appendChild(webPushDiscoveryContainer);
            ReactDOM.render(React.createElement(WebPushDiscovery, { calloutTarget: function () { return target_1; } }), webPushDiscoveryContainer);
        }
    }
});
//# sourceMappingURL=attachWebPushDiscovery.js.map